export const projectCode = 'clean_tech_commons';
